export default __webpack_public_path__ + "static/media/Americo.fe41cfb0.svg";